@if (isAvatarExist) {
  <nz-avatar [nzSrc]="avatarUrl" [nzSize]="size"></nz-avatar>
} @else {
  <nz-avatar
    [ngStyle]="{ 'background-color': profileColor }"
    [nzText]="initials"
    [nzSize]="size"
    [ngClass]="avatarSizeClass"
  ></nz-avatar>
}
